import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import {
  Typography,
  Box,
  Grid
} from '@mui/material';
import Main from 'layouts/Main';
import Container from 'components/Container';

function BlogPost() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://cms.akygacomponents.com/api/posts/${id}?populate=*`)
      .then((res) => res.json())
      .then((data) => {
        setPost(data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Błąd w fetch:', err);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <Main>
        <Container>
          <Typography variant="h4">Loading...</Typography>
        </Container>
      </Main>
    );
  }

  if (!post) {
    return (
      <Main>
        <Container>
          <Typography variant="h4">Post not found</Typography>
        </Container>
      </Main>
    );
  }

  const { title, header, carousel, content_1, content_2 } = post;
  
  const getImageUrl = (imageData) => {
    return imageData?.formats?.large?.url
      ? `https://cms.akygacomponents.com${imageData.formats.large.url}`
      : imageData?.formats?.medium?.url
      ? `https://cms.akygacomponents.com${imageData.formats.medium.url}`
      : imageData?.url
      ? `https://cms.akygacomponents.com${imageData.url}`
      : null;
  };

  return (
    <Main>
      <Container>
        <Typography component="h1" sx={{ mt: 4, mb: 1, fontWeight: 'bold', fontSize: '36px' }}>
          {title}
        </Typography>
        {header && <Typography variant="h5" component="h2" sx={{ mt: 1, mb: 5, fontWeight: 'medium' }}>
          {header}
        </Typography>}
        {content_1 && <ReactMarkdown>{content_1}</ReactMarkdown>}
        {carousel?.length > 0 && (
          <Box sx={{ mb: 4, mt: 6 }}>
            <Grid container spacing={2} justifyContent={carousel.length <= 2 ? "center" : "space-between"} sx={{ paddingLeft: 0 }}>
              {carousel.map((carouselImage, index) => (
                <Grid item xs={12} sm={6} md={4} key={index} sx={{ paddingLeft: '0 !important' }}>
                  <Box sx={{ textAlign: 'center', paddingLeft: 0 }}>
                    <Box
                      component="img"
                      width="325px"
                      height="325px"
                      src={getImageUrl(carouselImage)}
                      alt={carouselImage.alternativeText || `Zdjęcie ${index + 1}`}
                      sx={{ 
                        objectFit: 'cover',
                        borderRadius: 2,
                        boxShadow: 2,
                      }}
                    />
                    {carouselImage.caption && (
                      <Typography 
                        variant="body2" 
                        color="text.secondary"
                        sx={{ mt: 1, fontStyle: 'italic' }}
                      >
                        {carouselImage.caption}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
        {content_2 && <ReactMarkdown>{content_2}</ReactMarkdown>}
      </Container>
    </Main>
  );
}

export default BlogPost;
